import {Typography} from '@mui/material'
import styled from 'styled-components'
import {dividerColor, screenS, secondTextColor} from '@theme/vars'

export const ItemWrapper = styled.div`
  padding: 15px 5px 10px;
  border-bottom: 1px solid ${dividerColor};
`

export const PublicationDateWrapper = styled.div`
  padding-top: 6px;
`

export const MainDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;

  @media only screen and (max-width: ${screenS}) {
    flex-direction: column;
    &:not(:first-child) {
      margin-top: 12px;
    }
  }
`

export const FlexPublicationInfo = styled.div`
  width: calc(50% - 20px);
  @media only screen and (max-width: ${screenS}) {
    width: calc(85% - 20px);
    margin: 0;
  }
`

export const FlexExtSettings = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media only screen and (max-width: ${screenS}) {
    flex-direction: row-reverse;
    margin-top: 16px;
    justify-content: space-between;
  }
`

export const FlexSettings = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  & * + button {
    margin-left: 16px;
  }

  @media only screen and (max-width: ${screenS}) {
    justify-content: flex-start;
    text-align: left;
  }
`

export const FlexAuthors = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  color: ${secondTextColor};
  width: 21%;
  min-width: 200px;
  position: relative;

  @media only screen and (max-width: ${screenS}) {
    align-items: flex-start;
    width: 100%;
    min-width: 230px;
  }
`

export const AuthorsTitle = styled(Typography)`
  text-align: right;
`
